import { Component, Inject, NgZone, OnDestroy, Optional } from '@angular/core';
import { Observer } from '../../models/observer.interface';
import { NotifierService } from '../../services/notifier.service';
import { ActivatedRoute } from '@angular/router';
import { AuthCoreService } from '../../services/auth-core.service';
import { StatutService } from '../statut/statut.service';
import { AbstractSigaleComponent } from '../abstract-sigale.component';
import { DialogModule } from 'primeng/dialog';
import { StompService } from '../../services/stomp/stomp.service';
import { Subscription } from 'rxjs';
import { AppStatus } from '../statut/appStatus.model';

@Component({
	standalone: true,
	selector: 'statut-alert',
	templateUrl: './statut-alert.component.html',
	styleUrls: ['./statut-alert.component.scss'],
	imports: [
		DialogModule
	]
})
export class StatutAlertComponent extends AbstractSigaleComponent implements OnDestroy, Observer {
	open = false;
	titre: string;
	message: string;
	private appStatusAbonnement: Subscription;

	constructor(@Optional() private activeRoute: ActivatedRoute, private authService: AuthCoreService, private statutService: StatutService,
				@Optional() private notifierService: NotifierService, @Optional() private stompService: StompService, private ngZone: NgZone, @Optional() @Inject('$scope') private $scope: any
	) {
		super();
	}

	ngOnDestroy(): void {
		if (this.stompService) {
			this.stompService.desabonner(this.appStatusAbonnement);
		}
		else if (this.notifierService) {
			this.notifierService.disconnectFromTopic('appStatus');
		}
	}

	public notify(response: any): void {
		this.ngZone.run(() => {
			const appStatus = JSON.parse(response).data;
			this.onAppStatusReceived(appStatus);
		});
	}

	ngOnInit(): void {
		super.ngOnInit();

		if (this.stompService) {
			// le stompService fonctionne sur toutes les applications, en cohabitation ou non
			this.appStatusAbonnement = this.stompService.abonnerTopic('appStatus', (appStatus: AppStatus) => {
				this.ngZone.run(() => this.onAppStatusReceived(appStatus));
			});
		}
		else if (!this.modeApplicationCohabitation) {
			this.notifierService.subscribeToTopic(this, 'appStatus');
		}
		else if (this.$scope) {
			this.$scope.$on('app:dataReceived:APP_STATUS', (event, appStatus) => this.onAppStatusReceived(appStatus));
		}

		if (!this.modeApplicationCohabitation) {
			this.activeRoute.params.subscribe(routeParams => {
				this.statutService.getApplicationStatus().subscribe(appStatus => {
					this.onAppStatusReceived(appStatus);
				});
			});
		}

		this.titre = this.translateService.instant('SIGALE_ANGULAR.COMPONENTS.MODAL_MAINTENANCE.TITRE');
		this.message = this.translateService.instant('SIGALE_ANGULAR.COMPONENTS.MODAL_MAINTENANCE.MESSAGE');
	}

	private onAppStatusReceived(appStatus: any) {
		if (!this.authService.isAdminConnecte()) {
			this.open = appStatus.down;
		}
	}

	traductionFR(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"MODAL_MAINTENANCE": {
						"TITRE": "Maintenance en cours",
						"MESSAGE": "L'application est actuellement en cours de maintenance, il est impossible de l'utiliser pour le moment."
					}
				}
			}
		};
	}


	traductionIT(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"MODAL_MAINTENANCE": {
						"TITRE": "Manutenzione in corso",
						"MESSAGE": "Impossibile utilizzare l’applicazione peché attualmente in corso di manutenzione."
					}
				}
			}
		};
	}
}
